import React, { useEffect } from 'react';
import T from 'prop-types';
import { useDispatch } from 'react-redux';

import MarketOverview from '../components/MarketOverview';
import TrendsSummary from '../components/TrendsSummary';
import TimeSpentPenetration from '../components/TsPenetration';
import MarketBehavior from '../components/MarketBehavior';
import AppImpact from '../components/AppImpact';
import FullAccessBanner from '../components/FullAccessBanner';
import SectorsStats from '../components/SectorsStats';
import AppTrends from '../components/AppTrends';
import StickyAppsLine from '../components/StickyAppsLine';
import TabExportButton from '../components/TabExportButton';
import AiDashboardStaticView from '../components/AiDashboardStaticView';
import PreviewTopBanner from '../components/PreviewTopBanner';
import PreviewBottomSection from '../components/PreviewBottomSection';
import DashboardTabsBar from '../../_shared/components/DashboardTabsBar';
import DashboardStickyHeader, {
  useStickySentinel,
} from '../../_shared/components/DashboardStickyHeader';
import useDashboardNav, { scrollToSection } from '../../_shared/hooks/useDashboardNav';
import Container from '../../../../components/Container';
import { fetchAiDashboardData } from '../actions';
import { SECTIONS, SECTIONS_IDS, STATIC_VIEW_SECTIONS } from '../configs/sections';
import { dashboardName } from '../configs/constants';

const AiDashboardContainer = ({
  isPublic = false,
  campaignEnded = false,
  showAiBanner = false,
  isPress = false,
}) => {
  const dispatch = useDispatch();

  const sections = campaignEnded ? STATIC_VIEW_SECTIONS : SECTIONS;

  const { sentinelRef, sentinelNode } = useStickySentinel();
  const { active, isSticky } = useDashboardNav(sections, sentinelRef);

  useEffect(() => {
    dispatch(fetchAiDashboardData({ campaignEnded }));
  }, [dispatch, campaignEnded]);

  const tabsBar = (
    <DashboardTabsBar sections={sections} active={active} onScrollToSection={scrollToSection} />
  );

  return (
    <>
      {(isPublic || showAiBanner) && <PreviewTopBanner campaignEnded={campaignEnded} />}
      <div className="dashboard-tab ai-dashboard-tab">
        <DashboardStickyHeader
          isSticky={isSticky}
          title={dashboardName}
          icons={<StickyAppsLine active={active} />}
          actions={!isPress && <TabExportButton isPublic={isPublic || campaignEnded} />}
          tabs={tabsBar}
        />
        {sentinelNode}
        {tabsBar}
        <Container maxWidth={1128}>
          <div className="dashboard-tab-content">
            {campaignEnded ? (
              <AiDashboardStaticView />
            ) : (
              <>
                <div id={SECTIONS_IDS.marketOverview}>
                  <MarketOverview allowQV={!isPublic && !isPress} isPress={isPress} />
                </div>
                <div className="separator-h" />
                {isPublic && <FullAccessBanner />}
                <div id={SECTIONS_IDS.behavioralTrends}>
                  <TrendsSummary allowQV={!isPublic && !isPress} />
                </div>
                <div id={SECTIONS_IDS.shareOfScreenTime}>
                  <TimeSpentPenetration isPress={isPress} />
                </div>
                <div id={SECTIONS_IDS.marketBehavior}>
                  <MarketBehavior isPress={isPress} />
                </div>
                <div id={SECTIONS_IDS.screenTimeBySector}>
                  <SectorsStats />
                </div>
                <div id={SECTIONS_IDS.appTrends}>
                  <AppTrends isPress={isPress} />
                </div>
                <div id={SECTIONS_IDS.aiAppImpact}>
                  <AppImpact isPublic={isPublic} isPress={isPress} />
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
      {isPublic && <PreviewBottomSection />}
    </>
  );
};

AiDashboardContainer.propTypes = {
  isPublic: T.bool,
  campaignEnded: T.bool,
  showAiBanner: T.bool,
  isPress: T.bool,
};

export default AiDashboardContainer;
